import React from 'react';

import AccessTimeIcon from '@material-ui/icons/AccessTime';
import TaskAltIcon from '@material-ui/icons/CheckCircleOutlined';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import WarningAmberIcon from '@material-ui/icons/WarningOutlined';

export const STATUS_TO_COLOR_MAPPER = {
  completed: '#555893',
  need_help: '#ff73a2',
  not_started: '#b0b3f4',
  unable_to_diagnose: '#d9dbdeff'
};

export const STATUS_TO_ICON_MAPPER = {
  completed: <TaskAltIcon style={{ fontSize: 30 }} />,
  need_help: <WarningAmberIcon />,
  not_started: <AccessTimeIcon />,
  unable_to_diagnose: <HighlightOffIcon />
};
